import DataTable from "react-data-table-component";
import React from "react";
import { Button, Col, Row } from "reactstrap";
import moment from "moment";

export const SwitchStaffPaymentDetailsTable = ({ data }) => {

  const columns = [
    {
      name: "id",
      width: "150px",
      selector: (row) => row.id || "Not Available",
      sortable: true,
    },
    {
      name: "Created By",
      width: "150px",
      selector: (row) => row.createdBy?.name || "",
      sortable: true,
    },
    {
      name: "Amount",
      selector: (row) => row.amount?.toLocaleString() || "",
      sortable: true,
    },
    {
      name: "Created At",
      width: "200px",
      selector: (row) =>
        moment(parseInt(row?.createdAt)).format("DD-MM-YYYY hh:mm:ss"),
      sortable: true,
    },
    {
      name: "Payment Type",
      selector: (row) => row.paymentType || "Not Available",
      sortable: true,
    },
    {
      name: "Transaction Type",
      selector: (row) => {
        let type;
        switch (row.transactionType) {
          case "CC":
            type = row.CCType || "Visa";
            break;
          case "CQ":
            type = "Cheque";
            break;
          case "L":
            type = "Cash";
            break;
          case "CO":
            type = "complimentary";
            break;
          case "BA":
            type = "Bank";
            break;

          default:
            break;
        }
        return type;
      },
      sortable: true,
    },
    {
      name: "Counterparty",
      width: "200px",
      selector: (row) =>
        row.financialParty?.name ? (
          <span
            style={{
              color: row.isDeleted ? "red" : "inherit",
              fontWeight: row.isDeleted ? "bold" : "normal",
            }}
            title={row.isDeleted ? "Deleted Member" : ""}
          >
            {row.financialParty?.name}
          </span>
        ) : (
          "Not Available"
        ),
      sortable: true,
    },
    {
      name: "Membership",
      selector: (row) => row.membership?.id || "",
      sortable: true,
    },
    {
      name: "Member Sale Product",
      selector: (row) => row.memberSaleProduct?.id || "",
      sortable: true,
    },
    // {
    //   name: "Start Subscription",
    //   selector: (row) =>
    //     row?.startDate
    //       ? moment(row?.startDate).format("DD-MM-YYYY hh:mm:ss")
    //       : "",
    //   sortable: true,
    // },
    // {
    //   name: "End Subscription",
    //   selector: (row) =>
    //     row?.endDate
    //       ? moment(row?.endDate).format("DD-MM-YYYY hh:mm:ss")
    //       : "",
    //   sortable: true,
    // },
    // {
    //   name: "Note",
    //   selector: (row) => row?.note || "----------",
    //   sortable: true,
    // },
  ];

  return (
    <Row>
      <Col xs={12} className="mt-4">
      <DataTable
        responsive
        className="dark-blue-table"
        columns={columns}
        data={data}
      />
      </Col>
    </Row>
  );
};
